"use strict";
import storage from './storage';

/**
 *
 * sitesLocalStorageService
 *
 * @namespace sitesLocalStorageService
 * @ignore
 */

const STORAGE_METADATA = storage.metadata.SITES_LS;
const STORAGE_METADATA_REQUIRED = storage.metadata.SITES_LSR;
let publicMethods = {};
publicMethods.initStorage = function(){
    if (!storage(STORAGE_METADATA)) {
        storage(STORAGE_METADATA, {});
        return true;
    }
    return false;
};

publicMethods.getItem = function(key, required){
    publicMethods.initStorage();
    let storageVal = storage(STORAGE_METADATA);
    if (typeof(required) === 'boolean' && required) {
        storageVal = storage(STORAGE_METADATA_REQUIRED);
    }
    if (storageVal && storageVal.hasOwnProperty(key)) {
        let data = storageVal[key];
        if (!data.expiresAt || (data.expiresAt && !isExpired(data.expiresAt))) {
            return data;
        } else {
            publicMethods.removeItem(key);
            return false;
        }
    } else {
        return false;
    }

};

publicMethods.writeItem = function(key, data, required){
    publicMethods.initStorage();
    let storageVal = storage(STORAGE_METADATA);
    if (typeof(required) === 'boolean' && required) {
        storageVal = storage(STORAGE_METADATA_REQUIRED);
    }
    if (storageVal && data) {
        storageVal[key] = data;
        storage(STORAGE_METADATA, storageVal);
        return storageVal[key];
    }
    return false;
};

publicMethods.removeItem = function(key, required){
    let storageVal = storage(STORAGE_METADATA);
    if (typeof(required) === 'boolean' && required) {
        storageVal = storage(STORAGE_METADATA_REQUIRED);
    }
    if (storageVal && storageVal[key]) {
        delete storageVal[key];
        storage(STORAGE_METADATA, storageVal);
        return true;
    }
    return false;
};

publicMethods.removeAll = function(){
    storage.removeItem(STORAGE_METADATA);
    return true;
};

var isExpired = function(expireDate) {
    let currentDate = new Date();
    if (Date.parse(currentDate) < Date.parse(expireDate)) {
        return false;
    } else {
        return true;
    }
};

export default publicMethods;
